import { Component } from "react";
import QuaggaImpl from "../barcode/QuaggaImpl";

export class ProductScanner extends Component {
    render() {
        return <QuaggaImpl />
    }
}
